<template>
    <WindowLayout :title="title">
        <div class="row">
            <div class="col-sm-12">
                <div class="darmin card">
                    <div class="card-header pb-0 d-flex align-items-center">
                        <h5>{{ headerTitle }}</h5>
                    </div>
                    <div class="card-body theme-form">
                        <div class="row">
                            <div class="col">
                                <div class="mb-3 row">
                                    <label class="col-md-3 col-form-label">Titulo</label>
                                    <div class="col-md-9">
                                        <input
                                            class="form-control"
                                            type="text"
                                            v-model="form.state.title"
                                        />
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label class="col-md-3 col-form-label">Código</label>
                                    <div class="col-md-9">
                                        <input
                                            class="form-control"
                                            type="text"
                                            v-model="form.state.codigo"
                                        />
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label class="col-md-3 col-form-label">Body</label>
                                    <div class="col-md-9">
                                        <textarea
                                            class="form-control"
                                            rows="3"
                                            v-model="form.state.body"
                                        />
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label class="col-md-3 col-form-label">Target</label>
                                    <div class="col-md-9">
                                        <treeselect
                                            v-model="form.state.target"
                                            :options="darminComponents"
                                        ></treeselect>
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label class="col-sm-3 col-form-label">Estado</label>
                                    <div class="col-md-9">
                                        <SelectInputSimpleState
                                            v-model="form.state.status"
                                        ></SelectInputSimpleState>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-12 text-end">
                                <div
                                    v-if="!props.item"
                                    class="btn btn-primary ms-auto"
                                    @click="handleAction('create')"
                                >
                                    <i class="far fa-save"></i>
                                    Guardar
                                </div>
                                <div
                                    v-else
                                    class="btn btn-primary ms-auto"
                                    @click="handleAction('update')"
                                >
                                    Actualizar
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </WindowLayout>
</template>

<script setup>
import { defineProps, onMounted, ref } from 'vue';

import WindowLayout from '@/layouts/Window.layout.vue';
import SelectInputSimpleState from '@/components/form/SelectInputSimpleState.vue';
import Treeselect from 'vue3-treeselect';
// eslint-disable-next-line import/no-cycle
import DarminComponents from '@/DarminComponents';

import { useSnackbar } from 'vue3-snackbar';

import useTopics from './services/useTopics';
import { useTopicsForm } from './composables/useTopicsForm';

const props = defineProps({
    title: { type: String, default: 'Topics' },
    headerTitle: { type: String, default: 'Topic' },
    urlRead: { type: String, required: false },
    urlCreate: { type: String, required: false },
    urlUpdate: { type: String, required: false },
    item: Object,
});

const snackbar = useSnackbar();

const service = useTopics();
const { ...form } = useTopicsForm();

const darminComponents = ref([]);

onMounted(async () => {
    darminComponents.value = (await DarminComponents()).getSelect();
    if (props.item) {
        await Promise.all([service.getTopic(props.item.id)]);
        if (service.topic) {
            form.setState(service.topic.value);
        }
    }
});

const handleAction = async (action) => {
    await form.$v.value.$validate();
    if (!form.$v.value.$error) {
        switch (action) {
            case 'create':
                await service
                    .createTopic({
                        title: form.state.title,
                        codigo: form.state.codigo,
                        body: form.state.body,
                        target: form.state.target,
                    })
                    .then(() => {
                        snackbar.add({
                            type: 'success',
                            text: 'Topic creado correctamente',
                        });
                    })
                    .catch((error) => {
                        console.log(error);
                        error.data.errors.map((e) => {
                            snackbar.add({
                                type: 'error',
                                text: e.msg,
                            });
                            return false;
                        });
                    });
                break;

            case 'update':
                await service
                    .updateTopic(form.state.id, {
                        title: form.state.title,
                        codigo: form.state.codigo,
                        body: form.state.body,
                    })
                    .then(() => {
                        snackbar.add({
                            type: 'success',
                            text: 'Topic actualizado correctamente',
                        });
                    })
                    .catch((error) => {
                        console.log(error);
                        error.data.errors.map((e) => {
                            snackbar.add({
                                type: 'error',
                                text: e.msg,
                            });
                            return false;
                        });
                    });
                break;

            default:
                break;
        }
    } else {
        console.log(form.$v.value.$errors);
    }
    return true;
};
</script>
